import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const getBlog = () => api.get("/blog").then((r) => r.data);
export const getPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const postContact = (data) => api.post("/contact", data).then((r) => r.data);
export const postNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
export const reportSession = (minutes) =>
  api.post("/stats/session", { minutes }).then((r) => r.data).catch(() => null);
export const createCheckout = (data) => api.post("/payments/checkout", data).then((r) => r.data);
export const verifyPayment = (data) => api.post("/payments/verify", data).then((r) => r.data);
export const createReferral = (email) => api.post("/referrals", { email }).then((r) => r.data);
export const lookupReferral = (email) =>
  api.get("/referrals/lookup", { params: { email } }).then((r) => r.data);
export const validateCode = (code, email) =>
  api.get(`/referrals/validate/${encodeURIComponent(code)}`, { params: { email } }).then((r) => r.data);

export const REF_KEY = "gd_ref_code";
export const TRIAL_KEY = "gd_trial_email";
export const CURRENCY_KEY = "gd_currency";

export const getPricing = (params) => api.get("/pricing", { params }).then((r) => r.data);
export const startTrial = (email) => api.post("/trials", { email }).then((r) => r.data);
export const lookupTrial = (email) => api.get("/trials/lookup", { params: { email } }).then((r) => r.data);

export const money = (minor, pricing) => {
  const value = minor / 100;
  const whole = Number.isInteger(value);
  return `${pricing.symbol}${value.toLocaleString(pricing.locale, {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};

export const loadRazorpay = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve();
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = resolve;
    s.onerror = () => reject(new Error("Razorpay SDK failed to load"));
    document.body.appendChild(s);
  });
